var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/backward"
  }, /*#__PURE__*/React.createElement("g", {
    id: "backward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.3334 19.96V37.04C51.3334 40.54 47.5301 42.7334 44.4968 40.9834L37.1001 36.7367L29.7034 32.4667C29.2368 32.1867 28.8634 31.8834 28.5601 31.51V25.5367C28.8634 25.1634 29.2368 24.86 29.7034 24.58L37.1001 20.31L44.4968 16.0634C47.5301 14.2667 51.3334 16.46 51.3334 19.96Z",
    stroke: "#0C9BED",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.5598 19.96V37.04C28.5598 40.54 24.7564 42.7334 21.7231 40.9834L14.3265 36.7367L6.92979 32.4667C3.89645 30.7167 3.89645 26.3534 6.92979 24.58L14.3265 20.31L21.7231 16.0634C24.7564 14.2667 28.5598 16.46 28.5598 19.96Z",
    stroke: "#0C9BED",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.6b82bb6f47d0797b4fba77e019254269.svg";
export { ForwardRef as ReactComponent };